import { yupResolver } from '@hookform/resolvers/yup';
import { Description, Drafts, PeopleAlt, PersonAdd } from '@mui/icons-material';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  Grid,
  Box,
  TextField,
  InputAdornment,
  DialogActions,
  Button,
} from '@mui/material';
import { useForm } from 'react-hook-form';
import { adminSchema } from '../../../schemas/adminSchema';
import { swalClose, swalLoading, swalLoadingTimer } from '../../../helpers/swalHelper';
import { useEffect } from 'react';
import { omit } from 'lodash';

export default function AdminDialog({ open, onClose, mode, onSubmit, taxId, defaultValues }) {

  const { register, handleSubmit, reset, formState: { errors } } = useForm({
    defaultValues: {
        _id: defaultValues?._id || '',
        name: defaultValues?.name || '',
        one_mail: defaultValues?.one_mail || ''
    },
    resolver: yupResolver(adminSchema),
  });

  const handleSave = async (data) => {
    onClose();
    await swalLoadingTimer({ text: `กำลังอัพเดตข้อมูล` });
    if (taxId) {
        data.tax_id = taxId;
    }
    if (data?._id === '') {
      data = omit(data, ['_id']);
    }
    // console.log("data", data);
    onSubmit(data);
  }

  const handleClose = () => {
    onClose();
    handleClearFields();
  }

  const handleClearFields = () => {
    reset({
      name: '',
      one_mail: ''
    })
  };

  useEffect(() => {
      if (open) {
        reset({
            ...defaultValues,
        });
      }
  }, [open, defaultValues, reset]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{ style: { minWidth: 'auto', maxWidth: 'auto' } }}
    >
      <DialogTitle id="alret-dialog-title">
        <span> {mode === 'create' ? 'เพิ่มแอดมิน' : 'แก้ไขแอดมิน'} </span>
        <Box component="span" ml={1}>
          <PersonAdd />
        </Box>
      </DialogTitle>
      <DialogContent dividers>
        <DialogContentText>
          <Grid
            container
            spacing={1}
            sx={{ textAlign: 'center', marginTop: '5px' }}
          >
            { mode === 'create' && (
                <Grid item xs={12} md={6} sx={{ marginTop: '5px' }}>
                <TextField
                    value={taxId}
                    disabled
                    sx={{ backgroundColor: '#F0F0F0' }}
                    label="เลขประจำตัวผู้เสียภาษี"
                    variant="outlined"
                    InputProps={{
                    readOnly: true,
                    startAdornment: (
                        <InputAdornment position="start">
                        <Description/>
                        </InputAdornment>
                    ),
                    }}
                />
                </Grid>
            )}
            <Grid item xs={12} md={6} sx={{ marginTop: '5px' }}>
              <TextField
                {...register('name')}
                label="ชื่อ-นามสกุล"
                variant="outlined"
                placeholder="กรอกชื่อ-นามสกุล"
                error={!!errors.name}
                helperText={errors.name?.message}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <PeopleAlt/>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12} md={6} sx={{ marginTop: '5px' }}>
              <TextField
                {...register('one_mail')}
                label="One Mail"
                variant="outlined"
                placeholder="กรอกอีเมล"
                error={!!errors.one_mail}
                helperText={errors.one_mail?.message}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Drafts/>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
          </Grid>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          color="primary"
          onClick={handleSubmit(handleSave)}
        >
          {mode === 'create' ? 'สร้างรายการ' : 'บันทึกรายการ'}
        </Button>
        <Button onClick={handleClose} autoFocus color="error">
          ยกเลิก
        </Button>
        <Button onClick={handleClearFields} variant="outlined" color="error"> 
          Clear
        </Button>
      </DialogActions>
    </Dialog>
  );
}
